import type { DriverChecklistItem, DriverTimeEvent, LoadRecord } from '../types'

const now = new Date()
const tomorrow = new Date(Date.now() + 24 * 60 * 60 * 1000)

export const demoDriverLoad: LoadRecord = {
  id: 'demo-driver-load',
  load_number: 'LH-1028',
  customer_id: 'demo-customer-1',
  assigned_driver_id: 'demo-owner',
  status: 'in_transit',
  pickup_company: 'Titan Industrial',
  pickup_address: '4100 Railhead Road',
  pickup_city: 'Fort Worth',
  pickup_state: 'TX',
  pickup_contact: 'Marcus Reed',
  pickup_phone: '(817) 555-0129',
  pickup_at: now.toISOString(),
  pickup_instructions: 'Check in at Gate 3. Safety vest and hard hat required.',
  delivery_company: 'Permian Equipment',
  delivery_address: '2200 Industrial Avenue',
  delivery_city: 'Midland',
  delivery_state: 'TX',
  delivery_contact: 'Daniel Ortiz',
  delivery_phone: '(432) 555-0184',
  delivery_at: tomorrow.toISOString(),
  delivery_instructions: 'Call the delivery contact 30 minutes before arrival.',
  freight_description: 'Fabricated steel assembly on two skids',
  pieces: 2,
  estimated_weight: 12800,
  dimensions: '18 ft × 7 ft × 5 ft',
  equipment_requirements: '40 ft gooseneck',
  securement_requirements: 'Chains, binders, edge protection, and two straps',
  customer_rate: 2850,
  driver_pay: 0,
  estimated_fuel: 420,
  additional_expenses: 85,
  loaded_miles: 318,
  deadhead_miles: 22,
  current_eta: new Date(Date.now() + 2 * 60 * 60 * 1000).toISOString(),
  tracking_token: '8afacbe7-7537-40ba-8bc8-d4a6af86b5c1',
  tracking_visibility: 'city_state',
  driver_location_sharing_allowed: true,
  location_last_updated_at: new Date(Date.now() - 8 * 60 * 1000).toISOString(),
  location_last_latitude: 32.4487,
  location_last_longitude: -99.7331,
  location_accuracy_meters: 28,
  created_at: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
  customers: { company_name: 'Titan Industrial' },
  assigned_driver: { full_name: 'Jared Guinn' },
}

const checklistLabels = [
  ['pickup', 'confirm_pickup_location', 'Confirm pickup location and appointment', true],
  ['pickup', 'inspect_equipment', 'Inspect truck, trailer, straps, chains, and binders', true],
  ['pickup', 'confirm_freight', 'Confirm freight description, count, and weight', true],
  ['pickup', 'photo_before_loading', 'Photograph freight before loading', true],
  ['pickup', 'inspect_damage', 'Inspect and document existing damage', true],
  ['pickup', 'secure_load', 'Confirm freight is loaded and secured correctly', true],
  ['pickup', 'collect_bol', 'Collect or upload bill of lading', true],
  ['pickup', 'mark_loaded', 'Mark pickup complete and loaded', true],
  ['delivery', 'confirm_delivery_location', 'Confirm delivery location and appointment', true],
  ['delivery', 'confirm_arrival', 'Confirm arrival with the delivery contact', true],
  ['delivery', 'photo_before_unloading', 'Photograph freight before unloading when appropriate', false],
  ['delivery', 'confirm_recipient', 'Record recipient name and delivery time', true],
  ['delivery', 'collect_signature', 'Capture signature or signed proof of delivery', true],
  ['delivery', 'photo_completed_delivery', 'Photograph completed delivery when appropriate', false],
  ['delivery', 'document_concerns', 'Document damage, shortages, or delivery concerns', false],
  ['delivery', 'mark_delivered', 'Mark the load delivered', true],
] as const

export const demoChecklist: DriverChecklistItem[] = checklistLabels.map((item, index) => ({
  id: `demo-check-${index}`,
  load_id: demoDriverLoad.id,
  phase: item[0],
  item_key: item[1],
  label: item[2],
  required: item[3],
  sort_order: index,
  completed_at: item[0] === 'pickup' ? new Date(Date.now() - (90 - index * 5) * 60 * 1000).toISOString() : null,
  completed_by: item[0] === 'pickup' ? 'demo-owner' : null,
  notes: null,
}))

export const demoTimeEvents: DriverTimeEvent[] = [
  {
    id: 'demo-time-3',
    load_id: demoDriverLoad.id,
    driver_id: 'demo-owner',
    event_type: 'departed_pickup',
    occurred_at: new Date(Date.now() - 75 * 60 * 1000).toISOString(),
    notes: 'Freight secured and BOL uploaded.',
    latitude: null,
    longitude: null,
  },
  {
    id: 'demo-time-2',
    load_id: demoDriverLoad.id,
    driver_id: 'demo-owner',
    event_type: 'arrived_at_pickup',
    occurred_at: new Date(Date.now() - 140 * 60 * 1000).toISOString(),
    notes: null,
    latitude: null,
    longitude: null,
  },
  {
    id: 'demo-time-1',
    load_id: demoDriverLoad.id,
    driver_id: 'demo-owner',
    event_type: 'started_work',
    occurred_at: new Date(Date.now() - 210 * 60 * 1000).toISOString(),
    notes: null,
    latitude: null,
    longitude: null,
  },
]
